module.exports = __webpack_public_path__ + "../static/media/5629-font.f0a7ff15.ttf";